module.exports = __webpack_public_path__ + "static/media/object_immotal3.545a8cbb.png";